import {IAbTestingStrategy} from "../ab-testing-strategy.interface";
import {NullableString} from "../../../../../common/types/nullable-types";
import {IAbTestingData, IAbTestingFeature} from "../../ab-testing-feature-data-provider.service.interface";


export class VoidAbTestingStrategy implements IAbTestingStrategy {
    readonly anonymousPlayerId: NullableString = null;

    getFeature(featureName: string): IAbTestingFeature | null {
        return null;
    }

    waitForLoadTestData(): Promise<void> {
        return Promise.resolve();
    }

    testData(): Promise<IAbTestingData> {
        return Promise.resolve({
            ErrorDescription: '',
            Features: {},
            AnonymousPlayerId: ''
        });
    }
}